import { Outlet } from 'react-router';

import { OrganizationLoader } from '@/pages/OrganizationLoader';

export const LayoutPlain = () => {
  return (
    <OrganizationLoader>
      <Outlet />
    </OrganizationLoader>
  );
};

export default LayoutPlain;
